import { render, staticRenderFns } from "./receipt_button.vue?vue&type=template&id=37453fb0&scoped=true"
import script from "./receipt_button.vue?vue&type=script&lang=js"
export * from "./receipt_button.vue?vue&type=script&lang=js"
import style0 from "./receipt_button.vue?vue&type=style&index=0&id=37453fb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37453fb0",
  null
  
)

export default component.exports